exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea {\r\n\tresize: none;\r\n}\r\n\r\n.short-pay-div {\r\n    display: block;\r\n    padding: .5em;\r\n}", ""]);

// exports
